<template>
    <div>
        <v-card class="mx-1">
            <v-row>
                <v-card min-width="100%">
                    <v-card-text>
                        <v-row>
                            <v-col cols="11">
                                <v-card-title class="titulopagina">GENERAR TRAZABILIDAD</v-card-title>
                            </v-col>
                            <v-col cols="1">
                                <v-alert class="amber accent-2 text-center" color="orange" outlined dense @click="abrirAyudas">
                                    <v-icon color="blue" large>help</v-icon>
                                </v-alert>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-row>
            <v-row>
                <modal-ayuda></modal-ayuda>
            </v-row>
            <v-row>
                <v-card-text>
                    <v-row style="background-color:#fbe791;" dense>
                        <v-col cols="2">
                            <label>Fecha</label>
                            <date-picker 
                                v-model="fecha" 
                                placeholder ="Seleccione Fecha" 
                                format="DD-MM-YYYY" 
                                valueType="YYYY-MM-DD" 
                            ></date-picker>
                        </v-col>
                        <v-col cols="1">
                            <v-select
                                :items="lineas"
                                item-text="nombre_linea"
                                item-value="id"
                                v-model="lineas_id"
                                label="Seleccione Línea"
                                class="float-right"
                            ></v-select>
                        </v-col>
                        <v-col cols="2">
                            <v-select
                                :items="procesos"
                                item-text="tipo_materia_prima"
                                item-value="id"
                                v-model="tipo_proceso"
                                label="Seleccione Proceso"
                                class="float-right"
                            ></v-select>
                        </v-col>
                        <v-col cols="1">
                            <v-btn color="green" @click="cargarDatosFecha">BUSCAR</v-btn>
                        </v-col>
                        <v-col cols="1">
                            <v-alert dense text> <span style="font-size:1.2em"> {{rendimiento}} %</span> </v-alert>
                        </v-col>
                        <v-col cols="1">
                            <v-text-field
                                label="Kilos MMPP Total"
                                class="right-input"
                                v-model="kilos_mp"
                                @change="calcular_2cositas"
                            >
                            </v-text-field>
                        </v-col>
                        <v-col cols="1">
                            <v-text-field
                                label="Kilos seleccionados"
                                class="right-input"
                                readonly
                                v-model="total_kilos"
                            >
                            </v-text-field>
                        </v-col>
                        <v-col cols="1">
                            <v-text-field
                                label="Kilos faltantes"
                                class="right-input"
                                readonly
                                v-model="kilos_faltantes"
                            >
                            </v-text-field>
                        </v-col>
                        <v-col cols="2">
                            <v-text-field
                                label="Kilos Prod. Terminado"
                                class="right-input"
                                v-model="kilos_pt"
                                @change="calcular_rendimiento"
                            >
                            </v-text-field>
                        </v-col>
                    </v-row>
                    <v-row style="background-color:#fbe791;" dense>
                        <v-col cols="2">
                            <p style="margin-bottom: 0px;">Kilos MMPP día: {{info_mp | formatear_miles}} </p>
                        </v-col>
                        <v-col cols="2">
                            <p style="margin-bottom: 0px;">Kilos PT L.: {{info_pt | formatear_miles}}</p>
                        </v-col>
                        <v-col cols="3">
                        </v-col>
                        <v-col cols="2">
                            <p style="margin-bottom: 0px;">Producción (MMPP): {{ mmpp_prod | formatear_miles }}</p>
                        </v-col>
                        <v-col cols="1">
                        </v-col>
                        <v-col cols="2">
                            <p style="margin-bottom: 0px;">Producción (PT): {{ pt_prod | formatear_miles }}</p>
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <v-col cols="1">
                            <v-checkbox v-model="metodo" label="Opción 2" title="Solo marcar esta opción si la traza se genera mal de forma normal" ></v-checkbox>
                        </v-col>
                        <v-col cols="2">
                            <v-select
                                :items="procesos_filtrados"
                                item-text="tipo_materia_prima"
                                item-value="codigo"
                                v-model="tipo_mmpp"
                                label="Cambiar Tipo de Materia Prima"
                                class="float-right"
                                multiple
                                ></v-select>
                                <!-- @change="setCodigoProceso" -->
                        </v-col>
                        <v-col cols="3">
                            <v-btn color="blue" @click="generarTraza">GENERAR TRAZA</v-btn>
                            <v-btn class="ml-2" color="#00c853" title="Ver Rendimiento Maxis" @click="verRendimientoMaxis"> % </v-btn>
                            <v-btn class="ml-2" color="#ffb74d" title="Ver Fechas Guias Maxis" @click="verFechaGuiasMaxis"><v-icon>timer</v-icon></v-btn>
                        </v-col>
                        <v-col cols="4">
                            <!-- <tr v-for="pm in prod_maxis" :key="pm.id">
                                <td class="pr-2"> {{pm.linea}} </td> | 
                                <td class="pr-2 pl-2"> {{pm.materia_prima}} </td> | 
                                <td class="pr-2 pl-2"> {{pm.cant_jumbos}} maxis </td> | 
                                <td class="pl-2"> {{pm.total_kilos | formatear_miles}} kgs</td>
                            </tr>    -->                     
                        </v-col>
                        <v-col cols="1">
                            <v-checkbox
                                v-if="$tienePermiso('PRODUCCION_permitir_mezcla_materia_prima')"
                                v-model="permitir_mezcla"
                                label="Permitir mezcla MP"
                                title="Permite mezclar materia prima con y sin restricción para esta fecha"
                                dense
                                @change="setPermitirMezcla"
                            ></v-checkbox>
                        </v-col>
                        <v-col cols="1" style="background-color:#fbe791;" dense>
                            <v-btn color="orange" @click="grabarFecha" :disabled="traza.id < 0">MODIFICAR</v-btn>
                        </v-col>
                    </v-row>
                    <div class="d-flex justify-center">
                        <v-simple-table class="table-summary-maxis">
                            <thead>
                                <tr>
                                    <th class="text-center cabecera">Línea</th>
                                    <th class="text-center cabecera">Materia Prima</th>
                                    <th class="text-center cabecera">Cantidad Maxisacos</th>
                                    <th class="text-center cabecera">Kilos</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="pm in prod_maxis">
                                    <td> {{pm.linea}} </td>
                                    <td> {{pm.materia_prima}} </td>
                                    <td> 
                                        {{pm.cant_jumbos}} maxis
                                        <v-btn @click="verMaxis(pm)" icon><v-icon>visibility</v-icon></v-btn> </td>
                                    <td> {{pm.total_kilos | formatear_miles}} kgs</td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </div>
                </v-card-text>
            </v-row>
            <v-row class="d-flex justify-center">
                <v-alert
                    :value="alert.show"
                    color="red"
                    dark
                    icon="warning"
                    transition="scale-transition"
                    class="mt-4"
                >
                    {{alert.message}}
                    <v-btn icon @click="alert.show = false">
                        <v-icon>highlight_off</v-icon>
                    </v-btn>
                </v-alert>
              </v-row>
            <v-dialog
                v-if="prod_maxis_seleccionada != []"
                v-model="abrir_modal_maxisacos"
                width="500"
            >

                <v-card>
                    <v-card-title primary-title>
                        <v-list-item-content>
                            <v-list-item-title class="text-h5 mb-1">
                                Detalle de Maxisacos
                            </v-list-item-title>
                            <v-list-item-subtitle>
                                {{ `${prod_maxis_seleccionada.general.linea || ''} - ${prod_maxis_seleccionada.general.materia_prima || ''}`  }}
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-card-title>

                    <v-card-text>
                        <v-simple-table class="table-summary-maxis">
                            <thead>
                                <tr>
                                    <th class="text-center cabecera">Lote</th>
                                    <th class="text-center cabecera">Maxisacos</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(pm, lote) in prod_maxis_seleccionada.data">
                                    <td class="text-no-wrap"> {{ lote }} </td>
                                    <td class="jumbos-container">
                                        <template v-for="(jumbo, i) in pm">
                                            <span :class="jumbo.barrido && 'jumbos-container__jumbo-barrido'" :title="jumbo.barrido ? 'Maxisaco de barrido' : ''">
                                                {{jumbo.nro_jumbo}}
                                            </span> 
                                            <template v-if="i + 1 < pm.length">,</template>
                                        </template>
                                        
                                    </td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="primary"
                            text
                            @click="abrir_modal_maxisacos = false"
                        >
                            Cerrar
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-row>
                <v-col cols="6">
                    <v-simple-table 
                        dense 
                        fixed-header height="100%"
                        class="tablas-recepciones-maxis"
                    >
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th rowspan="2" class="text-center cabecera">?</th>
                                    <th class="text-center cabecera">Fecha - Hora</th>
                                    <th class="text-center cabecera">Ticket</th>
                                    <th class="text-center cabecera" rowspan="2">Restricción</th>
                                    <th class="text-center cabecera">Camión</th>
                                    <th class="text-center cabecera">Proveedor</th>
                                    <th class="text-center cabecera" rowspan="2">Peso Total</th>
                                    <th class="text-center cabecera" rowspan="2">Parcial</th>
                                    <th class="text-center cabecera" rowspan="2">Distribuir</th>
                                    <th class="text-center cabecera" rowspan="2">Falta</th>
                                </tr>
                                <tr>
                                    <th class="text-center cabecera">Planta</th>
                                    <th class="text-center cabecera">Guía</th>
                                    <th class="text-center cabecera">MP</th>
                                    <th class="text-center cabecera">Especie</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="e in recepciones_filtradas" :key="e.correlativo" v-bind:class="{active: e.seleccionada} ">
                                    <!-- <template v-if="e.mps_id == tipo_mmpp">  -->
                                    <template>
                                        <td>
                                            <input type="checkbox" @change="seleccionar($event, e)" :checked="e.seleccionada" />
                                            <br>
                                            <v-badge color="green" v-if="e.linea != null" :content="'L' + e.linea" ></v-badge>
                                        </td>
                                        <td  class="text-center">
                                            {{ e.fecha }}<hr/>
                                            {{ e.sucursal }}
                                        </td>
                                        <td class="text-center" v-bind:class="{restriccion: e.restriccion, restriccion_solo_usa: e.proceso == 7}">
                                            {{ e.ticket }}<hr/>
                                            {{ e.guia }} <br>
                                            <input type="checkbox" title="Usar fecha peso bruto para ticket" @change="usarOtraFecha($event, e)" :checked="e.otra_fecha!=null" />
                                            <the-mask v-if="e.otra_fecha!=null" 
                                                mask="####-##-## ##:##" 
                                                placeholder="aaaa-mm-dd hh:mm"
                                                class="text-right border-blue"
                                                v-model="e.otra_fecha"
                                                @change.native="cambiarFechaGuia($event, e)"
                                                masked="true"
                                                >
                                            </the-mask>
                                        </td>
                                        <td :class="[{restriccion: e.restriccion, restriccion_solo_usa: e.proceso == 7}, 'text-center', 'text-body-2']">
                                            <template v-if="e.proceso == 7">Exp Solo USA</template>
                                            <template v-else-if="e.restriccion">Con Restricción</template> 
                                            <template v-else>Sin restricción</template>
                                        </td>
                                        <td class="text-center" v-bind:class="{restriccion: e.restriccion, restriccion_solo_usa: e.proceso == 7}">
                                            {{ e.patente }}<hr/>
                                            {{ e.materia_prima }}
                                        </td>
                                        <td class="text-center">
                                            {{ e.empresa }}<hr/>
                                            {{ e.especie }}
                                        </td>
                                        <td class="text-center">
                                            {{ e.peso}}<hr/>
                                            <br>
                                            <v-badge style="margin-bottom:10px; margin-left:-30px;" color="green" v-if="e.dist_patio_texto != ''" :content="e.dist_patio_texto" ></v-badge>
                                        </td>
                                        <td>
                                            <v-text-field
                                                class="right-input"
                                                v-model="e.parcial"
                                                @change="parcialGuia($event, e)"
                                            ></v-text-field>
                                        </td>
                                        <td>
                                            <v-btn :class="`btn-dist dist-$e.correlativo`" small @click="distribuir($event, e)"><v-icon>share</v-icon></v-btn>
                                        </td>
                                        <td>
                                            <v-text-field
                                                class="right-input"
                                                v-model="e.falta"
                                                x-small
                                                dense
                                                readonly
                                            ></v-text-field>
                                        </td>
                                    </template>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </v-col>
                <v-col cols="1">
                </v-col>
                <v-col cols="5">
                    <v-simple-table dense fixed-header height="100%" class="tablas-recepciones-maxis">
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="text-center cabecera" rowspan="2">?</th>
                                    <th class="text-center cabecera" rowspan="2">Kilos MP</th>
                                    <th class="text-center cabecera" rowspan="2">Parcial</th>
                                    <th class="text-center cabecera">Lote</th>
                                    <th class="text-center cabecera" rowspan="2">Fecha Inicio</th>
                                    <th class="text-center cabecera" rowspan="2">Kilos Maxisaco</th>
                                    <th class="text-center cabecera" rowspan="2">Observación</th>
                                </tr>
                                <tr>
                                    <th class="text-center cabecera">Maxisaco</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="e in jumbos" :key="e.id" v-bind:class="{usado: e.tachar}">
                                    <!-- <template v-if="e.proceso == codigo_proceso"> -->
                                    <template>
                                        <td>
                                            <v-tooltip top color="blue darken-4" v-if="e.tachar == 1">
                                                <template v-slot:activator="{ on }">
                                                    <input v-on="on" type="checkbox" @change="agregar($event, e)" :checked="e.detalles_id > 0" />
                                                </template>
                                                <span>Maxisaco ha sido asignado también a otra guía {{ e.guia }}</span>
                                            </v-tooltip>
                                            <input v-if="e.tachar == 0" type="checkbox" @change="agregar($event, e)" :checked="e.detalles_id > 0" />
                                        </td>
                                        <td class="text-center">
                                            <v-text-field
                                                class="right-input"
                                                v-model="e.kilos"                                        
                                            ></v-text-field>
                                        </td>
                                        <td>
                                            <v-text-field
                                                class="right-input"
                                                v-model="e.parcial"
                                                @change="parcialMaxi($event, e)"
                                            ></v-text-field>
                                        </td>
                                        <td class="text-center">
                                            {{ e.lote }}
                                            <hr/>
                                            {{ e.maxisaco }} 
                                            <v-icon class="marca-barrido cursor-pointer" v-if="e.barrido" :title="`Lote siguiente: ${e.lote_siguiente_barrido}`">format_bold</v-icon>
                                        </td>
                                        <td class="text-center">
                                            {{ e.fecha }}
                                        </td>
                                        <td class="text-center">
                                            {{ e.peso }}
                                        </td>
                                        <td class="text-center">
                                            <v-text-field
                                                v-model="e.observacion"
                                            ></v-text-field>
                                        </td>
                                    </template>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </v-col>
            </v-row>
        </v-card>

        <v-snackbar
            v-model="snackbar"
            :color="color"
        >
            {{ message }}
            <template v-slot:action="{ attrs }">
                <v-btn
                    color="white"
                    text
                    v-bind="attrs"
                    @click="snackbar = false"
                >Cerrar</v-btn>
            </template>
        </v-snackbar>

        <v-dialog v-model="verModal" max-width="900px">
            <v-card>
                <v-card-title>
                    <span class="headline">Resumen Proceso Generar trazabilidad</span>
                </v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" dark @click="verModal = false" >Cerrar</v-btn>
                </v-card-actions>
                <v-card-text>
                    <v-container>
                        <div v-html="texto_modal"></div>
                    </v-container>
                </v-card-text>                
            </v-card>
        </v-dialog>


        <v-dialog
            v-model="dialogMaxis"
            activator=""
            width="900"
            @click:outside="dialogMaxis=false"
            persistent
        >
            <v-card>
                <v-row>
                    <v-col cols="8">
                        <v-card-title>
                            Rendimiento de Maxisacos
                        </v-card-title>
                    </v-col>
                    <v-col cols="4">
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" text @click="dialogMaxis=false"> Cerrar </v-btn>
                        </v-card-actions>
                    </v-col>
                </v-row>

               <v-simple-table dense fixed-header height="100%">
                    <template v-slot:default>
                        <thead>
                            <tr>
                                <th class="text-center cabecera" >Lote</th>
                                <th class="text-center cabecera" >Maxi</th>
                                <th class="text-center cabecera" >Kilos Maxisaco</th>
                                <th class="text-center cabecera" >Kilos MMPP</th>
                                <th class="text-center cabecera" >Rendim.</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="m in rendimientos" :key="m.id">
                                <td class="text-center"> {{ m.lote }} </td>
                                <td class="text-center"> {{ m.nro }} </td>
                                <td class="text-center"> {{ m.kilos }} </td>
                                <td class="text-center"> {{ m.mmpp }} </td>
                                <td class="text-center"> {{ m.rendim }} </td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </v-card>
        </v-dialog>


        <v-dialog
            v-model="dialogFechas"
            activator=""
            width="900"
            @click:outside="dialogFechas=false"
            persistent
        >
            <v-card>
                <v-row>
                    <v-col cols="8">
                        <v-card-title>
                            Fechas de Guias v/s Maxisacos
                        </v-card-title>
                    </v-col>
                    <v-col cols="4">
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" text @click="dialogFechas=false"> Cerrar </v-btn>
                        </v-card-actions>
                    </v-col>
                </v-row>

               <v-simple-table dense fixed-header height="100%">
                    <template v-slot:default>
                        <thead>
                            <tr>
                                <th class="text-center cabecera" >Ticket</th>
                                <th class="text-center cabecera" >Guía</th>
                                <th class="text-center cabecera" >Fecha Bruto</th>
                                <th class="text-center cabecera" >Fecha Ticket</th>
                                <th class="text-center cabecera" >Lote</th>
                                <th class="text-center cabecera" >Maxisaco</th>
                                <th class="text-center cabecera" >Fecha Maxisaco</th>
                            </tr>

                        </thead>
                        <tbody>
                            <tr v-for="m in fechas_traza" :key="m.id" v-bind:class="{restriccion: m.pintar == 1}" >
                                <td class="text-center"> {{ m.ticket }} </td>
                                <td class="text-center"> {{ m.guia }} </td>
                                <td class="text-center"> {{ m.fecha_i }} </td>
                                <td class="text-center"> {{ m.fecha_t }} </td>
                                <td class="text-center"> {{ m.lote }} </td>
                                <td class="text-center"> {{ m.maxi }} </td>
                                <td class="text-center"> {{ m.fecha_m }} </td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </v-card>
        </v-dialog>


    </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';
import {TheMask} from 'vue-the-mask';
import ModalAyudas from '../../components/shared/ModalAyudas.vue';

export default {
    data:()=>({
        dialogMaxis: false,
        dialogFechas: false,
        verModal:false,
        texto_modal:'',
        snackbar: false,
        message: '',
        color: 'green',
        fecha: null,
        kilos_mp: 0,
        kilos_pt: 0,
        info_pt: 0,
        info_mp: 0,
        mmpp_prod: 0,
        pt_prod: 0,
        rendimientos:[],
        fechas_traza:[],
        recepciones: [],
        jumbos: [],
        jumbos_guia: {
            guia: {},
            jumbos: []
        },
        guia: {},
        total_kilos: 0,
        kilos_faltantes: 0,
        total_jumbos: 0,
        traza: {
            id: 0,
            fecha: null,
            users_id: 0,
            kilos_mp: 0
        },
        prod_maxis:[],
        detalles: [],
        lineas: [],
        lineas_id: 1,
        procesos: [],
        procesos_filtrados: [],
        tipo_proceso: 1,
        codigo_proceso: 1,
        //codigo_proceso_mmpp: 1,
        tipo_mmpp: [],
        restriccion: false,
        permitir_mezcla: false,
        rendimiento: 0,
        metodo: 0,
        prod_maxis_list: [],
        prod_maxis_seleccionada: {
            general: {},
            data: [],
        },
        abrir_modal_maxisacos: false,
        alert: {
            show: false,
            message: '',
        }
    }),
    mounted(){
        this.fecha = this.moment().format("");
        this.cargarLineas();
        this.cargarProcesos();
        this.cargarDatosFecha();
    },
    methods: {
        abrirAyudas(){
            const jiji = [
                {   titulo:`Ayuda de Generar Trazabilidad`,    tipo:`titulo`},
                {   tipo:`label`,   texto:`En esta pantalla se genera la trazabilidad de la harina, asociando la materia prima que se ingresa a la planta de harina con el producto terminado.`},
                {   tipo:`label`,   texto:`- Se selecciona una fecha, una línea y un proceso y, al pulsar en el botón "Buscar", esto cargará toda la información de ese día que exista: la cantidad de producción registrada (con sus respectivas líneas, procesos, cantidad de maxisacos y de toneladas), la cantidad de producto terminado registrado y un listado de todas las guías con la materia prima seleccionada utilizadas ese día (en la tabla de la izquierda) y un listado de los maxisacos que se obtuvieron ese día (en la tabla de la derecha).`},
                {   tipo:`label`,   texto:`- En el listado de las guías de la tabla izquierda, se selecciona todas las que correspondan (de ese tipo de materia prima seleccionado) y, al pulsar en el botón "Generar Traza", estas son distribuidas en el listado de maxisacos de la tabla derecha. Una vez distribuidos, al pulsar en botón de columna "Distribuir", se mostrará en la tabla de la derecha los maxisacos que se hicieron a partir de la materia prima que se seleccionó.`},
                {   tipo:`label`,   texto:`- Al pulsar el botón con el icono del reloj, se muestran un listado uniendo las guías y los maxisacos que se generaron a partir de esa guía.`},
                {   tipo:`label`,   texto:`- Al pulsar el botón con el icono del porcentaje, se muestran un listado con el rendimiento de cada maxisaco en base a la materia prima utilizada.`},
                {   tipo:`label`,   texto:`- Finalmente, al pulsar en el botón "Modificar", se modificará la trazabilidad del día correspondiente con lo señalado en cada campo (Kilos MMPP Total, Kilos seleccionados, Kilos faltantes y Kilos Prod.Terminado).`},
            ];
            Event.$emit('mostrar_alert',jiji);
        },
        async cargarLineas(){
            let url = `${this.base_url}lineas`;
            await this.axios.get(url, this.headers).then((res)=>{
                this.lineas = res.data.data;
            }).catch((error)=>{
                console.log('error',error);
            });
        },
        async cargarProcesos(){
            let url = `${this.base_url}tipo_mp/traza`;
            await this.axios.get(url, this.headers).then((res)=>{
                this.procesos = res.data.data;
            }).catch((error)=>{
                console.log('error',error);
            });
        },
        cargarDatosFecha(){
            // Se cambia el tipo de materia prima de las guías (provenientes de sistema de Romana) por el proceso seleccionado y se dejan las recepciones (guías de romana), los jumbos (tabla maxisacos de la derecha) vacíos
            this.tipo_mmpp = [this.tipo_proceso];
            this.recepciones = [];
            this.jumbos = [];
            this.guia = {};
            this.total_jumbos = 0;
            // Se deja inputs de "Kilos seleccionados", "Kilos Prod. Terminado" y "Kilos MMPP Total" en 0
            this.total_kilos = 0;
            this.kilos_pt = 0;
            this.kilos_mp = 0;
            this.buscarTraza();
        },
        /**
         * Busca y obtiene los siguientes datos: 
         * - traza: los datos de la trazabilidad de la fecha que corresponde en tabla trazabilidad_fecha 
         * - detalles: los detalles de la trazabilidad de la fecha que corresponde en tabla trazabilidad_detalles
         * - prod_maxis: la cantidad total del peso de los jumbos asociados a los registros de tabla resultado_analisis agrupados por línea y por materia prima
         * 
         * - info_mp (Kilos MMPP día): la cantidad de kilos de materia prima del día provenientes de las guías del sistema de romana 
         * - info_pt (Kilos PT L.): la cantidad total de kilos en columna "peso" de tabla jumbos del día y de la línea correspondiente 
         * - mmpp_prod (Producción MMPP): la cantidad total de kilos en columna "mp_procesada" de tabla producción_turnos del día, de la línea y del proceso correspondiente 
         * - pt_prod (Producción PT): la cantidad total de kilos en columna "producción" de tabla producción_turnos del día, de la línea y del proceso correspondiente 
         */
        async buscarTraza(){
            this.mostrarLoading({titulo:'Cargando Datos...',color:'green'})
            // Se obtiene proceso seleccionado y se setea "codigo_proceso" dependiendo del código que tenga
            let pro = this.procesos.filter(r => {
                return r.id == this.tipo_proceso;
            });
            pro.forEach(p => {
                this.codigo_proceso = p.codigo;
                console.log(p.codigo);
            });
            // Se obtiene la fecha, linea y el id del tipo de proceso seleccionado y se dejan en el endpoint
            let fecha = this.moment(this.fecha).format("YYYY-MM-DD");
            let linea = this.lineas_id;
            let proceso = this.tipo_proceso;
            let url = `${this.base_url}traza/por_fecha/${fecha}/${linea}/${proceso}`;

            await this.axios.get(url, this.headers).then((res)=>{
                this.traza = res.data.traza;
                this.prod_maxis = res.data.prod_maxis;
                this.prod_maxis_list = res.data.prod_maxis_list;
                this.detalles = res.data.detalles;
                console.log("data",res.data);
                if(this.traza.id > 0){
                    this.kilos_mp = this.traza.kilos_mp;
                    this.kilos_pt = this.traza.kilos_pt;
                }
                this.info_pt = res.data.sum_jumbos;
                this.info_mp = res.data.sum_guias;
                this.mmpp_prod = res.data.mmpp_prod;
                this.pt_prod = res.data.pt_prod;

                this.mostrarLoading({ titulo: "Cargando recepciones y maxisacos... ", color: 'green'});
                Promise.all([
                    this.buscarMezcla(),
                    this.buscarRecepciones(false),
                    this.buscarJumbos(this.traza.id, 0, proceso, false),
                ]).then(() => {
                    this.ocultarLoading();
                });
                this.calcular_rendimiento();
            }).catch((error)=>{
                console.log('error',error);
                this.ocultarLoading();
            });
        },
        async buscarMezcla(){
            let fecha = this.moment(this.fecha).format("YYYY-MM-DD");
            let url = `${this.base_url}traza/mezcla/${fecha}/${this.lineas_id}/${this.tipo_proceso}`;
            await this.axios.get(url, this.headers).then((res)=>{
                this.permitir_mezcla = res.data.data.permitir_mezcla == 1;
                this.ajustarTipoMmpp();
            }).catch((error)=>{
                console.log('error',error);
            });
        },
        async setPermitirMezcla(){
            this.mostrarLoading({titulo:'Actualizando estado de mezcla...',color:'green'});
            let fecha = this.moment(this.fecha).format("YYYY-MM-DD");
            let body = {
                fecha: fecha,
                linea: this.lineas_id,
                proceso: this.tipo_proceso,
                permitir: this.permitir_mezcla ? 1 : 0,
            };
            let url = `${this.base_url}traza/mezcla`;
            await this.axios.post(url, body, this.headers).then((res)=>{
                this.ajustarTipoMmpp();
                this.showSnack(false, res.data.message);
            }).catch((error)=>{
                console.log('error', error);
                this.permitir_mezcla = !this.permitir_mezcla;
                this.showSnack(true, error.response && error.response.status === 403 ? error.response.data.message : 'Ha ocurrido un error al actualizar el estado de mezcla');
            });
            this.ocultarLoading();
        },
        ajustarTipoMmpp(){
            let proceso = this.procesos_filtrados.find(proceso => proceso.id === this.tipo_proceso);
            if (!proceso) {
                proceso = this.procesos_filtrados[this.procesos_filtrados.length - 1];
            }
            if (!proceso) return;
            if (this.permitir_mezcla && proceso.codigo == 1) {
                this.tipo_mmpp = [1, 2];
            } else {
                this.tipo_mmpp = [proceso.codigo];
            }
        },
        async generarTraza(){
            this.mostrarLoading({titulo:'Generando Trazabilidad...',color:'green'});
            let errors = [];
            //validaciones
            if(this.lineas_id <= 0) errors.push('Debe seleccionar una línea');
            if(this.kilos_mp <= 0) errors.push('Debe indicar Kilos MMPP');
            if(this.kilos_pt <= 0) errors.push('Debe indicar Kilos PT');

            if(errors.length > 0){
                this.ocultarLoading();
                this.showSnack(true, errors.join('. '));
                return;
            }
            let fecha = this.moment(this.fecha).format("YYYY-MM-DD");
            let url = `${this.base_url}traza/asociar/automatico`;
            let recepciones = this.recepciones.filter(r => {
                return r.seleccionada == 1;
            });
            let body = {
                fecha: fecha,
                kilos_mp: this.kilos_mp,
                kilos_pt: this.kilos_pt,
                lineas_id: this.lineas_id,
                tipo_mps_id: this.tipo_proceso,
                recepciones: recepciones,
                metodo: this.metodo
            };
            await this.axios.post(url, body, this.headers).then((res)=>{
                console.log(res.data);
                this.texto_modal = res.data.data;
                this.verModal = true;
                this.showSnack(false, 'Trazabilidad generada');
                this.alert = {
                    show: false,
                    message: '',
                }
                this.buscarTraza();
            }).catch((error)=>{
                this.ocultarLoading();
                console.log('error',error);
                this.alert = {
                    show: true,
                    message: error.response.status === 400 ? error.response.data.message : error || 'Ha ocurrido un error al generar la trazabilidad',
                }
            });
        },
        async buscarRecepciones(loader = true){
            if(loader) {
                this.mostrarLoading({titulo:'Cargando Recepciones...',color:'green'});
            }
            this.total_kilos = 0;
            let url = `${this.base_url}mp_procesada/recepciones/${this.fecha}/${this.lineas_id}/${this.tipo_proceso}`;
            await this.axios.get(url, this.headers).then((res)=>{
                this.recepciones = res.data;
                this.procesos_filtrados = this.filtrarProcesos();
                this.ajustarTipoMmpp();
                
                this.recepciones.forEach(r => {
                    let dets = this.detalles.filter(d => {
                        return (d.guias_id == r.guias_id);
                    });
                    if(dets.length > 0){
                        let dist = 0;
                        dets.forEach(d => {
                            if(d.parcial > 0){
                                dist += d.parcial;
                            }else{
                                dist += d.kilos;
                            }
                        });
                       // r.falta = r.parcial - r.total - r.distribuido;
                        //if((r.total - r.parcial) >  0){
                        //    r.falta = (r.total - r.distribuido) - (r.total - r.parcial);
                       // }
                        r.seleccionada = 1;
                    }
                    if(r.seleccionada == 1){
                        //console.log(r.parcial);
                        if(r.parcial > 0){
                            this.total_kilos += r.parcial;
                        }else{
                            this.total_kilos += r.total;
                        }
                    }
                });
                this.kilos_faltantes = this.kilos_mp - this.total_kilos;
                //this.setCodigoProceso();
            }).catch((error)=>{
                console.log('error',error);
            });
            if(loader) {
                this.ocultarLoading();
            }
        },
        /**
         * Busca todos los jumbos en base al id de la traza obtenido (trazabilidad_fecha) y al id de la guía (que es 0 en caso de que esto se realice al momento de buscar los datos (pulsando botón "Buscar")) y el proceso que corresponda. Esto obtiene información de los jumbos y de tabla de trazabilidad_detalle asociada al jumbo
         */
        async buscarJumbos(traza_id, guias_id, proceso, loader = true ){
            if(loader) {
                this.mostrarLoading({titulo:'Cargando Maxisacos...',color:'green'});
            }
            let url = `${this.base_url}traza/jumbos_guia/${traza_id}/${guias_id}/${proceso}`;
            await this.axios.get(url, this.headers).then((res)=>{
                this.jumbos = res.data.data.data;
                this.recepciones.map( function(fila){
                    if(fila.guias_id == res.data.data.guia ){
                        fila.falta = res.data.data.saldo_guia;
                    }
                    return fila;
                });
            }).catch((error)=>{
                console.log('error',error);
            });
            if(loader) {
                this.ocultarLoading();
            }
        },
        async grabarFecha(){
            let traza = {
                fecha: this.fecha,
                users_id: this.user.id,
                lineas_id: this.lineas_id,
                tipo_mps_id: this.tipo_proceso,
                kilos_mp: this.kilos_mp,
                kilos_pt: this.kilos_pt,
            };
            let url = `${this.base_url}trazabilidad`;
            await this.axios.post(url, traza, this.headers).then((res)=>{
                this.traza = res.data.data;
                this.showSnack(false, "Se ha grabado");
            }).catch((error)=>{
                console.log('error', error);
                this.showSnack(true, "Ha ocurrido un error");
            });
        },
        async grabarDetalle(j){
            if(!this.traza.id) return;
            this.mostrarLoading({titulo:'Grabando Detalle...',color:'green'});
            let detalle = {
                traza_id: this.traza.id,
                jumbos_id: j.id,
                observacion: j.observacion,
                ticket: this.guia.ticket,
                guia: j.guia,
                guias_id: this.guia.guias_id,
                kilos: j.kilos,
                parcial: j.parcial,
            };
            let url = `${this.base_url}traza/agregar_detalle`;
            await this.axios.post(url, detalle, this.headers).then((res)=>{
                let det = res.data.data;
                j.detalles_id = det.id;
                this.showSnack(false, "Se ha agregado ");
                if(this.traza.id > 0){
                    this.buscarJumbos(this.traza.id, this.guia.guias_id);
                }
                this.ocultarLoading();
            }).catch((error)=>{
                console.log('error', error);
                this.showSnack(true, "Ha ocurrido un error");
            });
        },
        async quitarDetalle(id){
            if(id == 0) return;
            let url = `${this.base_url}traza/quitar_detalle/${id}`;
            await this.axios.get(url, this.headers).then((res)=>{
                console.log(res.data.data);
                if(res.data.data.traza_id > 0){
                    this.buscarJumbos(res.data.data.traza_id, res.data.data.guias_id);
                }
                this.showSnack(false, "Se ha eliminado");
            }).catch((error)=>{
                console.log('error', error);
                this.showSnack(true, "Ha ocurrido un error");
            });
        },
        async agregarGuia(r){
            if(!this.traza.id) return;
            if (r.total < 0) {
                this.showSnack(true, "Error, no se puede procesar un valor negativo");
                return;
            }
            let guia = {
                traza_id: this.traza.id,
                guia: r.guia,
                guias_id: this.guia.guias_id,
                kilos: r.total,
                parcial: r.parcial,
            };
            let url = `${this.base_url}traza/agregar_guia`;
            await this.axios.post(url, guia, this.headers).then((res)=>{
                let tg = res.data.data;
                r.id = tg.id;
                r.seleccionada = true;
                this.showSnack(false, "Se ha agregado ... faltantes:" + this.kilos_faltantes);

            }).catch((error)=>{
                r.seleccionada = false;
                console.log('error', error);
                this.showSnack(true, error.response.status === 422 ? error.response.data.message : "Ha ocurrido un error");
            });
        },
        async quitarGuia(r){
            if(!this.traza.id || !r.id) {
                this.showSnack(true, "No se encuentra traza o id de guia");
                return;
            }
            let url = `${this.base_url}traza/quitar_guia/${r.id}`;
            await this.axios.get(url, this.headers).then((res)=>{
                console.log(res.data.data);
                r.falta = res.data.data.falta;
                r.total = res.data.data.falta;
                this.showSnack(false, "Se ha eliminado");
            }).catch((error)=>{
                console.log('error', error);
                this.showSnack(true, error);
            });
        },
        seleccionar(e, r){
            const checked = e.target.checked;
            e.target.checked = !checked;
            
            if(checked){
                // agregar mp de la guía seleccionada
                if(this.kilos_faltantes <= 0){
                    // si ya está completa la MP del día, no se deja seleccionar
                    e.target.checked = false;
                    this.showSnack(true, "No quedan Kilos para Seleccionar guías");
                    return;
                }
                if(this.kilos_mp <= 0){
                    // si no se ha registrado los kilos de MMPP
                    e.target.checked = false;
                    this.showSnack(true, "No se han indicado los kilos de MMPP Total");
                    return;
                }
                 if(parseInt(r.parcial) < parseInt(r.falta)){
                    console.log("oli");
                    r.falta = parseInt(r.parcial);
                }
                this.guia = r;
                r.seleccionada = 1;
                // si el total de esta guía es mayor que los kilos que faltan del día
                // se hace una asignacion parcial con los kilos faltantes y se deja disponible para distribuir
                if(r.total > this.kilos_faltantes){
                    r.parcial = this.kilos_faltantes;
                    r.falta = this.kilos_faltantes;
                    this.total_kilos += parseInt(r.parcial);
                }else{
                    // si no es mayor, se suma el total de la guía
                    this.jumbos_guia.guia = r;
                    this.total_kilos += parseInt(r.total);
                    r.falta = r.total;
                    r.parcial = r.total;
                }
                this.agregarGuia(r);
            }else{
                // quitar mp de la guía deseleccionada, lo parcial o el total
                this.guia = null;
                this.jumbos_guia.guia = null;
                //if(r.parcial == 0){
                //   this.total_kilos -= parseInt(r.total);
                //    r.falta = r.total;
                //}else{
                    this.total_kilos -= parseInt(r.parcial);
                    r.falta = r.parcial;
                //}
                r.seleccionada = 0;
                r.parcial = 0;
                r.falta = 0;
                if(this.total_kilos < 0) this.total_kilos = 0;
                // sacar todos los jumbos asignados a la guia
                this.jumbos.forEach(j => {
                    j.guia = 0;
                });
                this.quitarGuia(r);
            }
            this.kilos_faltantes = this.kilos_mp - this.total_kilos;
        },
        distribuir(e, r){   //  btn-dist dist-$e.correlativo
            if(r.seleccionada == 0) return;
            // si no hay una asociación parcial ya realizada se calcula cuanto falta
            if(r.distribuido > 0){
                if(r.parcial > 0){
                    r.falta = r.peso - r.distribuido;
                }else{
                    r.falta = r.peso - r.distribuido;
                }
            }
            r.distribuir = 1;
            this.guia = r;

            const clasDist = document.querySelectorAll('.btn-dist');
            clasDist.forEach(element => {
                element.style.backgroundColor = "#f5f5f5";
            });

            let t = e.target.type == "button" ? e.target : e.target.parentElement.parentElement;            
            t.style.backgroundColor = "#8f8";
            this.total_jumbos = 0;
            if(this.traza.id > 0){
                this.buscarJumbos(this.traza.id, r.guias_id);
            }
        },
        agregar(e, j){
            // se calcula la MP usada en el jumbo, según rendimiento
            j.kilos = parseInt(this.kilos_mp * j.factor);
            let continuar = true;
            // si no se ha presionado el boton distribuir o ya se distribuyó todo, se sale
            if(this.guia.distribuir == 0 && e.target.checked == true) continuar = false;
            // se obtienen los kilos de la guia (totales o parciales)
            let kilos_guia = this.guia.parcial > 0 ? this.guia.parcial : this.guia.total;
            // si el jumbo ya está en otra guía, se sale
            //if(j.tachar > 0) continuar = false;
            // se vuelve el checkbox a su estado anterior y sale
            if(!continuar){
                e.target.checked = !e.target.checked;
                this.showSnack(true, "No se puede distribuir. Guía no elegida o ya distribuida");
                return;
            }
            // si se elige el jumbo, se agrega al total los kilos de MP
            if(e.target.checked){
                // se verifica la hora
                let hora_guia = this.moment(this.guia.fecha);
                let hora_jumbo = this.moment(j.fecha);
                if(hora_guia > hora_jumbo){
                    e.target.checked = !e.target.checked;
                    this.showSnack(true, "La hora del maxisaco es anterior a la de la guía");
                    return;
                }
                // se calcula si la MP usada en este jumbo completa la guia
                if(this.guia.falta < j.kilos){
                    j.parcial = this.guia.falta;
                } else{
                    j.parcial = j.kilos;
                }
                if(j.parcial == 0){
                    this.total_jumbos += parseInt(j.kilos);
                }else{
                    this.total_jumbos += parseInt(j.parcial);
                }
                j.guia = this.guia.guia;
                this.grabarDetalle(j);
            }else{
                // si no se elige el jumbo, se descuenta del total los kilos de MP
                 if(j.parcial == 0){
                    this.total_jumbos -= parseInt(j.kilos);
                }else{
                    this.total_jumbos -= parseInt(j.parcial);
                }
                j.guia = 0;
                if(this.total_jumbos < 0) this.total_jumbos = 0;
                this.quitarDetalle(j.detalles_id);
            }
            // se calcula cuanta MP de la guía actual falta por distribuir
            let dif = kilos_guia - this.total_jumbos;
            this.guia.falta = dif;
            if(dif <= 0) {
                this.guia.distribuir = 0;
            }else{
                this.guia.distribuir = 1;
            }
        },
        /* setTipoMmpp(){
            let pro = this.procesos.filter(r => {
                return r.id == this.tipo_proceso;
            });
            pro.forEach(p => {
                this.tipo_mmpp = [p.mp_tipos_romana2];
                //this.codigo_proceso = p.codigo;
                console.log(p.mp_tipos_romana2);
            });
        }, */
        /* setCodigoProceso(){
            console.log("filter", this.procesos);
            let pro = this.procesos.filter(r => {
                return r.id == this.tipo_mmpp[0];
            });
            pro.forEach(p => {
                this.codigo_proceso_mmpp = p.codigo;
                console.log("this.codigo_proceso", this.codigo_proceso);
            });
        }, */
        async parcialMaxi(e,data){
            console.log(data);
            if(!data.detalles_id) return;
            let guia = {
                detalles_id: data.detalles_id,
                guia_id: data.guia,
                parcial: e,
                linea: this.lineas_id,
            };
            let url = `${this.base_url}traza/parcial_maxi`;
            await this.axios.post(url, guia, this.headers).then((res)=>{
                this.showSnack(false, res.data.message );
                console.log(res.data.data.traza_id);
                if(res.data.data.traza_id > 0){
                    this.buscarJumbos(res.data.data.traza_id, res.data.data.guias_id);
                }
            }).catch((error)=>{
                console.log('error', error);
                this.showSnack(true, error);
            });
        },
        async parcialGuia(e,data){
            console.log(data);
            if(!data.guias_id) return;
            let guia = {
                traza_id: this.traza.id,
                guia: data.guia,
                guias_id: data.guias_id,
                kilos: data.total,
                parcial: data.parcial,
            };
            let url = `${this.base_url}traza/parcial_guia`;
            await this.axios.post(url, guia, this.headers).then((res)=>{
                this.recepciones.map( function(fila){
                    if(fila.guias_id == res.data.data.guias_id ){
                        fila.parcial = parseInt(res.data.data.parcial);
                        if(parseInt(fila.parcial) < parseInt(fila.falta)){
                            fila.falta = parseInt(fila.parcial);
                        }
                    }
                    return fila;
                });
                this.calcula_seleccionados();
                this.showSnack(false, res.data.message );
                console.log(res.data.data);
            }).catch((error)=>{
                console.log('error', error);
                this.showSnack(true, error);
            });
        },
        async usarOtraFecha(e,data){
            console.log(e);
            if(!data.guias_id) return;
            let check = 0;
            if(e.target.checked){ check = 1; }

            let guia = {
                traza_id: this.traza.id,
                guia: data.guia,
                guias_id: data.guias_id,
                check: check,
            };
                
            let url = `${this.base_url}traza/usar_otra_fecha`;
            await this.axios.post(url, guia, this.headers).then((res)=>{
                this.recepciones.map( function(fila){
                    if(fila.guias_id == res.data.data.guias_id ){
                        fila.otra_fecha = res.data.data.otra_fecha;                        
                    }
                    return fila;
                });

                this.showSnack(false, res.data.message );
                console.log(res.data.data);
            }).catch((error)=>{
                console.log('error', error);
                this.showSnack(true, error);
            });
        },
        async cambiarFechaGuia(e,data){
            console.log('data-',data, ' -e-',e);
            if(!data.guias_id) return;
            let fecha = null;
            if(e.target.value){ fecha = e.target.value; }
            let guia = {
                traza_id: this.traza.id,
                guia: data.guia,
                guias_id: data.guias_id,
                fecha: fecha,
            };
            let url = `${this.base_url}traza/cambiar_fecha_guia`;
            await this.axios.post(url, guia, this.headers).then((res)=>{
                this.showSnack(false, res.data.message );
                console.log(res.data.data);
            }).catch((error)=>{
                console.log('error', error);
                this.showSnack(true, error);
            });
        },
        calcula_seleccionados(){
            let seleccionados = 0;
            this.recepciones.forEach(p => {
                seleccionados += parseInt(p.parcial);
            });
            this.total_kilos = seleccionados;
            this.kilos_faltantes = parseInt(this.kilos_mp) - parseInt(this.total_kilos);
        },
        calcular_rendimiento(){
            if(this.kilos_mp > 0){
                this.rendimiento = this.kilos_pt / this.kilos_mp * 100;
                this.rendimiento = this.rendimiento.toFixed(1);
            } else {
                this.rendimiento = 0;
            }
            console.log(this.rendimiento);
        },
        calcular_2cositas(){
            this.kilos_faltantes = this.kilos_mp - this.total_kilos; 
            this.calcular_rendimiento();
        },
        showSnack(error = false, message){
            this.message = message;
            if(error){
                this.color = "red darken-3";
            }else{
                this.color = "green darken-3";
            }
            this.snackbar = true;
        },
        async verRendimientoMaxis(){
            this.mostrarLoading({titulo:' Calculando Rendimiento Maxisacos...',color:'green'});
            let url = `${this.base_url}traza/rendimientos/${this.traza.id}`;
            await this.axios.get(url,this.headers).then(async (res)=>{
                this.dialogMaxis = true;
                this.rendimientos = res.data.data;
                console.log('rendimientos',this.rendimientos);
            }).catch((error)=>{
                console.log('error',error);
                this.showSnack(true, error);
            });
            this.ocultarLoading();
        },
        async verFechaGuiasMaxis(){
            this.mostrarLoading({titulo:' Calculando Fecha Tickets v/s Maxisacos...',color:'green'});
            let url = `${this.base_url}traza/fechas_traza/${this.traza.id}`;
            await this.axios.get(url,this.headers).then(async (res)=>{
                this.dialogFechas = true;
                this.fechas_traza = res.data.data;
                console.log('fechas_traza',this.fechas_traza);
            }).catch((error)=>{
                console.log('error',error);
                this.showSnack(true, error);
            });
            this.ocultarLoading();
        },

        verMaxis(item) {
            const prod_maxis_seleccionada = this.prod_maxis_list.filter(lote => lote.linea === item.linea && lote.materia_prima === item.materia_prima);
            const prod_maxis_agrupada = Object.groupBy(prod_maxis_seleccionada, ({nombre_lote}) => nombre_lote);
            this.prod_maxis_seleccionada = {
                general: {
                    linea: item.linea,
                    materia_prima: item.materia_prima,
                },
                data: prod_maxis_agrupada,
            };
            this.abrir_modal_maxisacos = true;
        },

        filtrarProcesos() {
            const codigos_procesos = {
                1: [1],
                2: [1, 2, 5],
                5: [1, 2, 5],
                7: [1, 2, 5, 7],
            }
            const proceso_encontrado = this.procesos.find(pro => pro.id === this.tipo_proceso);
            if(!proceso_encontrado) return [];
            let codigos = codigos_procesos[proceso_encontrado.codigo] || [];
            if(this.permitir_mezcla && proceso_encontrado.codigo == 1){
                codigos = [1, 2];
            }
            return this.procesos.filter(proceso => codigos.includes(proceso.codigo));
        },

        ...mapMutations(['mostrarLoading','ocultarLoading'])
    },
    computed: {
        ...mapState(['base_url', 'headers', 'user']),
        recepciones_filtradas() {
            return this.recepciones.filter(r => this.tipo_mmpp.includes(r.proceso));
        },
    },
    components:{
        DatePicker,TheMask,
        'modal-ayuda': ModalAyudas,
    }
}
</script>
<style scoped>
    .col{
        padding: 5px 12px;
    }
    .v-data-table--fixed-header thead tr:nth-child(4) th {
        top: 96px;
    }
    .v-data-table--fixed-header thead tr:nth-child(3) th {
        top: 64px;
    }
    .v-data-table--fixed-header thead tr:nth-child(2) th {
        top: 32px;
    }
    .table-summary-maxis {
        border: thin solid rgba(0, 0, 0, 0.12);
    }
    table tr td{
        border-right: thin solid rgba(0, 0, 0, 0.12);
    }
    table tr th{
        border-right: thin solid rgba(0, 0, 0, 0.12);
    }
    .active{
        background-color: #c5d9fd !important;
    }
    .restriccion{
        background-color: #f4b1b1 !important;
    }

    .restriccion_solo_usa {
        background-color: salmon !important;
    }
    .todo{
        background-color: #c5fdea !important;
    }
    .usado{
        background-color: #fdf0c5 !important;
    }
    .parcial{
        background-color: #f7fdc5 !important;
    }
    .right-input > input{
        text-align: right;
    }
    input[type=checkbox] {
        -ms-transform: scale(2); /* IE */
        -moz-transform: scale(2); /* FF */
        -webkit-transform: scale(2); /* Safari y Chrome */
        -o-transform: scale(2); /* Opera */
        padding: 10px;
        margin-bottom: 5px !important;
    }
    .cabecera{font-size: 0.9em !important;}
    .green{color:white;font-weight: bold;}
    .border-blue{border: green 1px solid; background-color: white;}

    /* .jumbos-container {
        display: flex;
        gap: 2px;
        align-items: center;
    } */

    .jumbos-container__jumbo-barrido {
        border: red solid 1px;
        border-radius: 50%;
        height: max-content;
        padding: 1px;
        min-width: 20px;
        width: max-content;
        display: inline-flex;
        justify-content: center;
        align-items: center;
    }
    .marca-barrido {
        color: red;
        border-radius: 100%;
    }

    .marca-barrido:hover {
        background-color: #f4c7c7;
    }

    .cursor-pointer {
        cursor: pointer;
    }
    .tablas-recepciones-maxis {
        overflow-y: auto;
        height: 900px;
    }
    .tablas-recepciones-maxis thead tr {
        position: sticky;
        height: 44px;
        z-index: 1;
    }

    .tablas-recepciones-maxis thead tr:nth-last-of-type(1) {
        top: 44px;
    }
</style>